
import { Container, Row, Col } from "react-bootstrap";

import 'animate.css';

import React from 'react';
import { Card } from 'react-bootstrap';
import { motion } from 'framer-motion';

export const Contact = () => {

  return (
    <section className="contact" id="contact">
      <Container className="my-5">
        <h1 className="text-center mb-4 text-light">Contact Us</h1>

        {/* Overall Coordinators */}
        <Row className="mb-4">
          <Col md={12}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <Card className="contact-card">
                <Card.Header className="contact-header">
                  <h4>Overall Coordinators</h4>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mr. Suriya Prakash M</h5>
                      <p>Phone: +91 93445 15110</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mr. Karl Marx K</h5>
                      <p>Phone: +91 95975 06987</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Ms. Harini S</h5>
                      <p>Phone: +91 91235 63065</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* Event Coordinators */}
        <Row className="mb-4">
          <Col md={12}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <Card className="contact-card">
                <Card.Header className="contact-header">
                  <h4>Overall Event Coordinators</h4>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mr. Abishek M</h5>
                      <p>Phone: +91 63793 62078</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Ms. Monisha B</h5>
                      <p>Phone: +91 72007 03455</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mr. Syed kasim samadh S</h5>
                      <p>Phone: +91 97513 55750</p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* Faculty Coordinators */}
        <Row className="mb-4">
          <Col md={12}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <Card className="contact-card">
                <Card.Header className="contact-header">
                  <h4>Faculty Coordinators</h4>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-4">
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mrs. S. Gospeline Christiana</h5>
                      <p>AP/AIML</p>
                      <p>Phone: +91 97863 47392</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mrs. S. Dyana</h5>
                      <p>AP/AIML</p>
                      <p>Phone: +91 80569 38733</p>
                    </Col>
                    <Col md={4} className="contact-person">
                      <h5 style={{ color: "gold" }}>Mrs. R. Rajashri</h5>
                      <p>AP/AIML</p>
                      <p>Phone: +91 98428 81990</p>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>





    </section>
  )
}
